import HttpMethodType from 'HttpMethodType';
import SubSystemType from 'SubSystemType';
import BaseServiceRequest from 'BaseServiceRequest';

class GetFundManagementDataRequest extends BaseServiceRequest {
    constructor(fundticker, isEntitled = false) {
        super();
        super.addRequestUri("fundmanagement.pb");
        super.addRequestParameter("fts", fundticker);
        super.addRequestParameter("ame", isEntitled ? "1" : "0");
    }

    getMethod() {
        return HttpMethodType.GET;
    }

    getSubSystem() {
        return SubSystemType.GRAPH;
    }

    getMessageName() {
        return "FundManagementTeamDataResponse";
    }
}

export default GetFundManagementDataRequest;
